module.exports = __webpack_public_path__ + "media/images/emblems/Amriswil_CoA-9f63152bd63b8d71e674ad4711cf0800.svg";